module.exports = __webpack_public_path__ + "static/img/robot.ff2c898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/robot.png
// module id = 336
// module chunks = 2